import {
  Component,
  Inject,
  OnInit,
  Signal,
  ViewChild,
  effect,
  inject,
} from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { PostDescriptionComponent } from "./post-description/post-description.component";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { StateService } from "projects/shared-state/lib/state.service";
import { PostGoalComponent } from "./post-goal/post-goal.component";
import { PostToneComponent } from "./post-tone/post-tone.component";
import { WorkflowState } from "projects/shared-state/public-api";
import { Workflow } from "projects/shared-state/lib/types/types";
import { asapScheduler } from "rxjs";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { Router } from "@angular/router";

@Component({
  standalone: true,
  selector: "app-postgenie-process",
  templateUrl: "./postgenie-process.component.html",
  styleUrls: ["./postgenie-process.component.scss"],
  imports: [
    CommonModule,
    MatCardModule,
    MatTabsModule,
    PostDescriptionComponent,
    PostGoalComponent,
    PostToneComponent,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class PostgenieProcessComponent implements OnInit {
  stateService = inject(StateService);
  router = inject(Router);

  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  public initDisablePage$ = true;
  public disablePage$: boolean = false;
  public step: number = 0;

  public expectedResult: string = "";
  public blurmessage = {
    postDescription: "Processing and classifying your post description...",
    postGoal: "Processing and classifying your post goal...",
    postFinal: `Great idea! Hang on just a bit while we are generating your post..`,
  };

  constructor(
    public dialogRef: MatDialogRef<PostgenieProcessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { workflowId: string | undefined },
  ) {
    // If workflowId is not given, ngrx store (effects) leads to the correct
    // data
    effect(() => {
      const workflow: Workflow = this.stateSignal$().workflow.workflow;
      const error: boolean = this.stateSignal$().workflow.error;
      if (workflow.uid && workflow.uid !== "") {
        this.initDisablePage$ = false;
        this.step = workflow.step - 1;
      }
      if (this.disablePage$) {
        this.enablePageStatus(workflow);
      }
      if (error) {
        this.handleError();
      }
    });

    if (this.data.workflowId) {
      this.stateService.getWorkflow(this.data.workflowId);
    }
  }

  // Animation
  public animationTime: number = 500;

  ngOnInit(): void {}

  setDisablePageStatus(event): void {
    this.expectedResult = event;
    this.disablePage$ = true;
  }

  onTabChanged(index): void {
    this.stateService.updateWorkflow({
      ...this.stateSignal$().workflow.workflow,
      step: index + 1,
    });
  }

  closeDialog(reason): void {
    this.dialogRef.close(reason);
  }

  enablePageStatus(workflow: Workflow): void {
    switch (this.expectedResult) {
      case "postDescription": {
        this.disablePage$ =
          workflow.promptWorkflow.aiResults.postDescription === "";
        if (!this.disablePage$) {
          this.step += 1;
        }
        break;
      }
      case "postGoal": {
        this.disablePage$ = workflow.promptWorkflow.aiResults.postGoal === "";
        if (!this.disablePage$) {
          this.step += 1;
        }
        break;
      }
      case "postFinal": {
        this.disablePage$ = workflow.promptWorkflow.aiResults.postFinal === "";
        if (!this.disablePage$ && this.router.url.includes("post")) {
          this.dialogRef.close("final post");
        } else if (!this.disablePage$ && this.router.url.includes("home")) {
          this.router.navigate(["post"], {
            queryParams: {
              workflow_id: this.stateSignal$().workflow.workflow.uid,
            },
            queryParamsHandling: "merge",
          });
          this.dialogRef.close("final post");
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  handleError(): void {
    this.disablePage$ = false;
    asapScheduler.schedule(() => {
      this.stateService.updateErrorState(false);
      if (this.step < 2) {
        this.stateService.saveWorkflow(
          {
            ...this.stateSignal$().workflow.workflow,
            activeStep: this.stateSignal$().workflow.workflow.activeStep - 1,
          },
          this.stateSignal$().workflow.workflow.uid,
        );
      }
    });
  }
}
